import { createStandaloneToast } from '@chakra-ui/react';

const toast = createStandaloneToast();

interface IToastProps {
  title: string;
  message?: string;
  id?: string
  duration?: number
}

console.log(toast);
export const ToastService = {
  showSuccessTaost: ({ title, message, id }: IToastProps) => {
    if (!toast.toast.isActive(id || 'success')) {
    toast.toast({
      id: id || 'success',
      title,
      description: message,
      variant: 'solid',
      position: 'top-right',
      isClosable: true,
      status: 'success',
    });
  }
  },
  showErrorToast: ({ title, message, id }: IToastProps) => {
    if (!toast.toast.isActive(id || 'error')) {
    toast.toast({
      id: id || 'error',
      title,
      description: message,
      variant: 'solid',
      position: 'top-right',
      status: 'error',
      isClosable: true,
    });
  }
  },
  showInfoToast: ({ title, message, id, duration }: IToastProps) => {
    if (!toast.toast.isActive(id || 'info')) {
    toast.toast({
      id: id || 'info',
      title,
      description: message,
      duration: duration || 3000,
      position: 'top-right',
      variant: 'subtle',
      status: 'info',
    });
  }
  },
};
